// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-intro-section {
    background-color: black;
    padding: 20px 0;
    text-align: center;
    overflow: hidden; /* Wichtig: Verhindert, dass Inhalte den Rahmen sprengen */
  }
  
  .video-intro-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    background-color: #a1a1a12a;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    gap: 20px;
    align-items: center;
    overflow: hidden; /* Wichtig: Verhindert, dass Animationen den Rahmen sprengen */
  }
  
  /* Video Section */
  .video-section {
    flex: 1 1;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
    opacity: 0;
    transform: translateX(-50px); /* Startet von links */
    transition: opacity 1s ease, transform 1s ease;
  }
  
  .fade-in-left {
    opacity: 1;
    transform: translateX(0); /* Zurück zur ursprünglichen Position */
  }
  
  .video-wrapper {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
    overflow: hidden;
  }
  
  .video-element {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  /* Text Section */
  .video-description-section {
    flex: 1 1;
    text-align: left;
    color: white;
    opacity: 0;
    transform: translateX(50px); /* Startet von rechts */
    transition: opacity 1s ease, transform 1s ease;
  }
  
  .fade-in-right {
    opacity: 1;
    transform: translateX(0); /* Zurück zur ursprünglichen Position */
  }
  
  .video-description-title {
    font-size: 1.5rem;
    margin-bottom: 15px;
    color: #ffffff;
  }
  
  .video-description-text {
    color: #9b9b9b;
    font-size: 1rem;
    margin: 5px 0;
  }
  
  /* Mobile Responsive Design */
  @media (max-width: 768px) {
    .video-intro-container {
      flex-direction: column;
      padding: 15px;
      overflow: hidden; /* Verhindert das Überschreiten des Rahmens */
    }
  
    .video-section,
    .video-description-section {
      width: 100%; /* Volle Breite */
    }
  
    .video-wrapper {
      padding-top: 56.25%;
    }
  
    .video-description-section {
      text-align: center;
      transform: translateX(20px); /* Dezenter Effekt für mobile Ansicht */
      transition: opacity 1s ease, transform 1s ease;
    }
  
    .fade-in-right {
      transform: translateX(0); /* Zurück zur ursprünglichen Position */
    }
  }
  
  @media (max-width: 480px) {
    .video-description-title {
      font-size: 1.2rem;
    }
  
    .video-description-text {
      font-size: 0.85rem;
    }
  
    .video-description-section {
      transform: translateX(10px); /* Noch subtilerer Effekt für kleine Bildschirme */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/components/Video.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB,EAAE,0DAA0D;EAC9E;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB,EAAE,8DAA8D;EAClF;;EAEA,kBAAkB;EAClB;IACE,SAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;IAC1C,UAAU;IACV,4BAA4B,EAAE,sBAAsB;IACpD,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,wBAAwB,EAAE,uCAAuC;EACnE;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAE,sBAAsB;IAC3C,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA,iBAAiB;EACjB;IACE,SAAO;IACP,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,2BAA2B,EAAE,uBAAuB;IACpD,8CAA8C;EAChD;;EAEA;IACE,UAAU;IACV,wBAAwB,EAAE,uCAAuC;EACnE;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE;MACE,sBAAsB;MACtB,aAAa;MACb,gBAAgB,EAAE,6CAA6C;IACjE;;IAEA;;MAEE,WAAW,EAAE,iBAAiB;IAChC;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,2BAA2B,EAAE,uCAAuC;MACpE,8CAA8C;IAChD;;IAEA;MACE,wBAAwB,EAAE,uCAAuC;IACnE;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,2BAA2B,EAAE,kDAAkD;IACjF;EACF","sourcesContent":[".video-intro-section {\r\n    background-color: black;\r\n    padding: 20px 0;\r\n    text-align: center;\r\n    overflow: hidden; /* Wichtig: Verhindert, dass Inhalte den Rahmen sprengen */\r\n  }\r\n  \r\n  .video-intro-container {\r\n    max-width: 1000px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    background-color: #a1a1a12a;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    gap: 20px;\r\n    align-items: center;\r\n    overflow: hidden; /* Wichtig: Verhindert, dass Animationen den Rahmen sprengen */\r\n  }\r\n  \r\n  /* Video Section */\r\n  .video-section {\r\n    flex: 1;\r\n    border-radius: 10px;\r\n    overflow: hidden;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);\r\n    opacity: 0;\r\n    transform: translateX(-50px); /* Startet von links */\r\n    transition: opacity 1s ease, transform 1s ease;\r\n  }\r\n  \r\n  .fade-in-left {\r\n    opacity: 1;\r\n    transform: translateX(0); /* Zurück zur ursprünglichen Position */\r\n  }\r\n  \r\n  .video-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n    padding-top: 56.25%; /* 16:9 Aspect Ratio */\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .video-element {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n  }\r\n  \r\n  /* Text Section */\r\n  .video-description-section {\r\n    flex: 1;\r\n    text-align: left;\r\n    color: white;\r\n    opacity: 0;\r\n    transform: translateX(50px); /* Startet von rechts */\r\n    transition: opacity 1s ease, transform 1s ease;\r\n  }\r\n  \r\n  .fade-in-right {\r\n    opacity: 1;\r\n    transform: translateX(0); /* Zurück zur ursprünglichen Position */\r\n  }\r\n  \r\n  .video-description-title {\r\n    font-size: 1.5rem;\r\n    margin-bottom: 15px;\r\n    color: #ffffff;\r\n  }\r\n  \r\n  .video-description-text {\r\n    color: #9b9b9b;\r\n    font-size: 1rem;\r\n    margin: 5px 0;\r\n  }\r\n  \r\n  /* Mobile Responsive Design */\r\n  @media (max-width: 768px) {\r\n    .video-intro-container {\r\n      flex-direction: column;\r\n      padding: 15px;\r\n      overflow: hidden; /* Verhindert das Überschreiten des Rahmens */\r\n    }\r\n  \r\n    .video-section,\r\n    .video-description-section {\r\n      width: 100%; /* Volle Breite */\r\n    }\r\n  \r\n    .video-wrapper {\r\n      padding-top: 56.25%;\r\n    }\r\n  \r\n    .video-description-section {\r\n      text-align: center;\r\n      transform: translateX(20px); /* Dezenter Effekt für mobile Ansicht */\r\n      transition: opacity 1s ease, transform 1s ease;\r\n    }\r\n  \r\n    .fade-in-right {\r\n      transform: translateX(0); /* Zurück zur ursprünglichen Position */\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .video-description-title {\r\n      font-size: 1.2rem;\r\n    }\r\n  \r\n    .video-description-text {\r\n      font-size: 0.85rem;\r\n    }\r\n  \r\n    .video-description-section {\r\n      transform: translateX(10px); /* Noch subtilerer Effekt für kleine Bildschirme */\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
